import { connect } from "react-redux";
import { Dispatch } from "redux";
import { MEMBERS_PORTAL } from "../../../accounts/Consts";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { clearSectionNotifications } from "../../../redux/middleware/clearSectionNotificationsMiddleware";
import { setCurrentPage, toggleTopMenuIsActive } from "../../../redux/reducers/HomeReducer";
import { createNewDraftAgreement, createNewDraftSetLists, createNewDraftWork, mp_addTab } from "../../../redux/reducers/MembersPortalReducer";
import { showModal } from "../../../redux/reducers/ModalReducer";
import { addTab } from "../../../redux/reducers/RepertoireReducer";
import { displayCustomerLogoThunk } from "../../../redux/thunks/HomeThunks";
import { createMembersPortalLivePerformanceThunk, getUploadCueSheetsFilesThunk } from "../../../redux/thunks/MembersPortalThunks";
import { FormatFields } from "../../../redux/types/FormatFields";
import IAppState from "../../../redux/types/IAppState";
import IMembersPortalComponentDataItem from "../../../redux/types/IMembersPortalComponentDataItem";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import { Header } from "./Header";
import { clearAppStateAndReinitializeThunk } from "../../../redux/thunks/AppInitializationThunks";

export default connect(
  (state: IAppState) => ({
    menuItems: state.home.menuItems,
    currentPage: state.home.currentPage,
    topMenuIsActive: state.home.topMenuIsActive,
    username: state.account.currentUser,
    currentViewAsUserName: state.account.currentViewAsUserName,
    isSignedIn: state.account.isSignedIn,
    enabledModules: state.home.enableModules,
    displayCustomerLogo: state.home.displayCustomerLogo,
    logoAddresses: state.home.logoAddresses,
    isLogoRequested: state.home.isLogoRequested,
    portalType: state.account.portalType,
    client: state.account.client,
    customer: state.account.customer,
    currentUserNameNumber: state.account.currentUserNameNumber,
    currentUserAccountNumber: state.account.currentUserAccountNumber,
    lookupValues: state.lookupEntities,
    jobs: state.job && state.job.jobs,
  }),
  (dispatch: Dispatch, ownProps) => ({
    setCurrentPage: (link: string) => dispatch(setCurrentPage(link)),
    clearSectionNotifications: () => clearSectionNotifications(dispatch),
    toggleTopMenuIsActive: () => dispatch(toggleTopMenuIsActive()),
    getDisplayCustomerLogo: () => dispatch<any>(displayCustomerLogoThunk()),
    addTab: (tab: ITabReduxItem, portalType: string) => {
      portalType == MEMBERS_PORTAL
        ? dispatch(mp_addTab(tab))
        : dispatch(addTab(tab));
    },
    addWork: (
      lookups: ILookupDictionary,
      currentUserNumber: string,
      formats?: FormatFields[],
    ) =>
      dispatch(
        createNewDraftWork(lookups, currentUserNumber, true, null, formats),
      ),
    addSetLists: (lookups: ILookupDictionary, currentUserNumber: string) =>
      dispatch(createNewDraftSetLists(lookups, currentUserNumber, true, null)),
    addAgreements: (
      lookups: ILookupDictionary,
      currentUserNumber: string,
      isNew?: boolean,
      draftAgreementsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem,
    ) =>
      dispatch(
        createNewDraftAgreement(
          lookups,
          currentUserNumber,
          isNew,
          draftAgreementsMaintenanceGeneralDataViewData,
        ),
      ),
    addLivePerformance: (
      lookups: ILookupDictionary,
      isNew?: boolean,
      livePerformanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem,
      formats?: FormatFields[],
      distributionCode?: string,
      currentUserNameNumber?: string,
    ) =>
      dispatch<any>(
        createMembersPortalLivePerformanceThunk(
          lookups,
          currentUserNameNumber,
          livePerformanceMaintenanceGeneralDataViewData,
        ),
      ),
    uploadCueSheets: (currentUserNumber: string) =>
      dispatch<any>(getUploadCueSheetsFilesThunk(currentUserNumber)),
    showModal: (
      modalContent: string,
      modalComponentInstance: string,
      modalProps: any,
      displayModalCloseButton: boolean,
      title: string,
    ) =>
      dispatch(
        showModal(
          modalContent,
          modalComponentInstance,
          modalProps,
          displayModalCloseButton,
          title,
        ),
      ),
    clearAppStateAndReinitialize: (
      portalType: string,
      currentUserEmail?: string,
    ) =>
      dispatch<any>(
        clearAppStateAndReinitializeThunk({
          portalType,
          currentUserEmail,
        }),
      ),
  }),
)(Header);